import { KpiFactboxTwoMetricVizViews } from '../types';
import { twoColumnFactboxViewConfig } from './two-column-factbox/view-config';

export const twoMetricKpiFactboxViewConfigs = [
  {
    name: KpiFactboxTwoMetricVizViews.FACTBOX,
    viewConfig: twoColumnFactboxViewConfig,
  },
];
